import { render } from "./MyLeaves.vue?vue&type=template&id=034a07b6"
import script from "./MyLeaves.vue?vue&type=script&lang=js"
export * from "./MyLeaves.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__